export default __webpack_public_path__ + "static/media/success-icon.bb101982.svg";